const Schedule = () => (
    <section id="schedule" className="bg-[#3a3a3a] py-16, parallax">
  
    <div className="content">
      <h2 className="text-4xl md:text-5xl font-bold text-[#FFD700] mb-6">Class Schedule</h2>
      <table className="w-full max-w-[600px] mx-auto border-collapse border border-[#00b7eb] bg-[#2c2c2c]/90">
        <thead>
          <tr>
            {['Day', 'Class', 'Time', 'Instructor'].map(header => (
              <th key={header} className="border border-[#00b7eb] p-2 bg-[#32cd32] text-white text-left">{header}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {[
            { day: 'Monday', cls: 'Boxing', time: '6:00 PM - 7:00 PM', instructor: 'Chris' },
            { day: 'Wednesday', cls: 'Spin', time: '5:30 PM - 6:15 PM', instructor: 'Jess' },
            { day: 'Friday', cls: 'Power Yoga', time: '6:30 PM - 7:30 PM', instructor: 'Sam' }
          ].map(row => (
            <tr key={row.cls}>
              <td className="border border-[#00b7eb] p-2 text-[#e0e0e0]">{row.day}</td>
              <td className="border border-[#00b7eb] p-2 text-[#e0e0e0]">{row.cls}</td>
              <td className="border border-[#00b7eb] p-2 text-[#e0e0e0]">{row.time}</td>
              <td className="border border-[#00b7eb] p-2 text-[#e0e0e0]">{row.instructor}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </section>
 
);

export default Schedule;